import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=5d8eed4f&scoped=true&"
import script from "./DefaultFooter.vue?vue&type=script&lang=js&"
export * from "./DefaultFooter.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=5d8eed4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8eed4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VBtn,VFooter})
